import * as React from 'react';
import Dropzone from 'react-dropzone';
import request from 'superagent';
import LoadingDisplay from '../Shared/Loading';
import { CheckCircle as SuccessIcon, GetApp as GetAppIcon, } from '@mui/icons-material';
import {
    Grid2 as Grid,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableHead,
    Tooltip,
    Typography,
    Fab,
    TextareaAutosize,
    ListItemIcon,
    Fade,
    CircularProgress,
    ListItemText,
    TableContainer,
    Paper,
    Box,
} from '@mui/material';
import classNames from 'classnames'
import { IGenericUserProps } from '../../DataClasses/GenericUser';
import { SubmissionType, MessageType, ValidationMessage } from '../../DataClasses/SharedData';
import { styled } from '@mui/material/styles';
import UserMessage from '../Shared/Message';
import SharedUtility from '../../Utilities/SharedUtility';
import { v4 as uuidv4 } from "uuid";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from "rxjs";
import DbService from '../Services/DbService';
import { Link } from 'react-router-dom';
import saveAs from 'file-saver';
import JSZip from 'jszip';
import ReportService from "../Services/ReportsService";
import SubmissionsService from '../Services/SubmissionsService';
import { ISelectedSubmissions, ISelectedSubmissionsHolder } from '../../DataClasses/SubmissionData';
import ProcessingDisplay from '../Shared/ProcessingDisplay';

import ListItemButton from "@mui/material/ListItemButton";

// Styled components for the dropzone
const DropzoneContainer = styled('div')(({ theme }) => ({
    outline: '2px dashed #92b0b3',
    outlineOffset: '-10px',
    fontSize: '1.25rem',
    backgroundColor: '#c8dadf',
    position: 'relative',
    padding: '100px 20px',
    textAlign: 'center',
    minHeight: '300px',
    '&.dropzone--isActive': {
        outlineOffset: '-20px',
        outlineColor: '#c8dadf',
        backgroundColor: '#fff',
    }
}));

const StatusBox = styled('div')<{ status: string }>(({ theme, status }) => {
    const getStatusColors = () => {
        switch (status) {
            case 'Success':
                return { backgroundColor: '#008000', color: 'white', width: '75px' };
            case 'Error':
                return { backgroundColor: '#FF0000', color: 'white', width: '75px' };
            case 'Warning':
                return { backgroundColor: '#ffae42', color: 'white', width: '75px' };
            case 'NotSubmitted':
                return { backgroundColor: '#B0C4DE', color: 'white', width: '90px' };
            case 'Submitted':
                return { backgroundColor: '#FFA500', color: 'white', width: '90px' };
            case 'Processed':
                return { backgroundColor: '#008000', color: 'white', width: '90px' };
            default:
                return { backgroundColor: '#cccccc', color: 'black', width: '75px' };
        }
    };

    return {
        textAlign: 'center',
        verticalAlign: 'center',
        height: '22px',
        ...getStatusColors()
    };
});

export interface IFile {
    fileId: string,
    fileName: string,
    submissionID: number,
    component: string,
    productLine: string,
    isProcessed: boolean,
    isValidated: boolean,
    errorMessage: string
}

export interface INonSurveyFile extends IFile {
    firstTierValidationStatus: string,
    firstTierValidationCount: number,
    secondTierValidationStatus: string,
    secondTierValidationCount: number,
    thirdTierValidationStatus: string,
    thirdTierValidationCount: number,
    validationStatus: string,
}

export interface ISurveyFile extends IFile {
    submissionDateTime: Date,
    submissionStatus: string,
    result: string,
}

interface ILocalProps {
    fileId: string,
    fileName: string,
    submissionID: number,
    component: string,
    productLine: string,
    isProcessed: boolean,
    isValidated: boolean,
    errorMessage: string
}

export interface INonSurveyFile extends IFile {
    firstTierValidationStatus: string,
    firstTierValidationCount: number,
    secondTierValidationStatus: string,
    secondTierValidationCount: number,
    thirdTierValidationStatus: string,
    thirdTierValidationCount: number,
    validationStatus: string,
}

export interface ISurveyFile extends IFile {
    submissionDateTime: Date,
    submissionStatus: string,
    result: string,
}

enum StatusType {
    Error = "Error",
    Fatal = "Fatal",
    WarningsAndErrors = "WarningsAndErrors",
    SchemaError = "SchemaError",
    Success = "Success",
    Warning = "Warning",
    Submitted = "Submitted",
    NotSubmitted = "NotRun",
    Processed = "Processed",
    NoIssues = "NoIssues",
}

interface ILocalProps {
    uploadFileType: string,
    allowMultiple: boolean,
    acceptFilesOfType: string
}

// local state
interface ILocalState {
    isDownloadUploadReport: boolean,
    isDownloadValidationReport: boolean,
    processingText: string,
    transactionId: string,
    completed: number,
    disableDropzone: boolean,
    nonSurveyFiles: INonSurveyFile[],
    surveyFiles: ISurveyFile[],
    showDownloadLink: boolean,
    dropzoneActive: boolean,
    filesNotProcessed: string[],
    uploadValidationMessages: ValidationMessage[],
    processingFiles: boolean
}

class BulkUploadDropzoneView extends React.Component<IGenericUserProps & ILocalProps, ILocalState> {

    constructor(props: IGenericUserProps & ILocalProps) {
        super(props);

        this.state = {
            isDownloadUploadReport: false,
            isDownloadValidationReport: false,
            processingText: "",
            transactionId: "",
            completed: 0,
            disableDropzone: false,
            nonSurveyFiles: [],
            surveyFiles: [],
            showDownloadLink: false,
            dropzoneActive: false,
            filesNotProcessed: [],
            uploadValidationMessages: [],
            processingFiles: false
        }
    }

    public render() {
        return (
            <Box sx={{ marginTop: 2 }}>

                {this.state.uploadValidationMessages && this.state.uploadValidationMessages.length > 0 &&
                    <Box sx={{ marginBottom: 2 }}>
                        <UserMessage text={this.getValidationMessageList()} variant={MessageType.Error} />
                    </Box>
                }

                <Grid container={true} justifyContent="center" alignItems="center" direction="row">
                    <Grid size={12}>
                        {this.state.processingFiles ?
                            <div>
                                <LoadingDisplay size={300} />
                                <Typography variant='subtitle1' color='primary' sx={{ fontWeight: 'bold' }}>
                                    Processing Status
                                </Typography>
                                <TextareaAutosize
                                    name="validationText"
                                    style={{ width: '100%' }}
                                    id="multiline-filled-static"
                                    disabled={true}
                                    maxRows={15}
                                    value={this.state.processingText}
                                />
                            </div>

                            :
                            <Dropzone
                                onDragEnter={this.onDragEnter}
                                onDragLeave={this.onDragLeave}
                                onDrop={this.onDrop}
                                multiple={this.props.allowMultiple}
                                disabled={this.state.disableDropzone}
                                accept={this.props.acceptFilesOfType as any}
                            >


                                {({ getRootProps, getInputProps, isDragActive }) => {
                                    return (
                                        <DropzoneContainer
                                            {...getRootProps()}
                                            className={classNames('dropzone', { 'dropzone--isActive': isDragActive })}
                                        >
                                            <input {...getInputProps()} />
                                            <Grid container={true} justifyContent="center" alignItems="center" direction="column">
                                                <Grid size={12}>
                                                    <Typography variant="h6" color="textPrimary">
                                                        Drag and drop file here
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <Typography variant="h6" color="textPrimary">
                                                        or
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <Fab sx={{ borderRadius: 1 }} variant="extended" color="primary">
                                                        Select File
                                                    </Fab>
                                                </Grid>
                                            </Grid>
                                        </DropzoneContainer>
                                    )
                                }}
                            </Dropzone>
                        }
                    </Grid>
                </Grid>
                <div>
                    {this.props.uploadFileType === SubmissionType.HEDIS &&
                        this.state.nonSurveyFiles != null &&
                        this.state.nonSurveyFiles.length > 0 ?
                        <div className="panel panel-default">
                            <div className="panel-body">
                                {this.renderDownloadReportLink(() => this.getUploadReport(), this.state.isDownloadUploadReport, "Upload Report")}
                                {this.renderDownloadReportLink(() => this.downloadBulkFiles(), this.state.isDownloadValidationReport, "Validation Report")}
                                <TableContainer component={Paper}>
                                    <Table className='table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>File Name</TableCell>
                                                <TableCell>Submission ID</TableCell>
                                                <TableCell>Processing Status</TableCell>
                                                <TableCell>Overall Validation Status</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                this.state.nonSurveyFiles != null &&
                                                this.state.nonSurveyFiles.length > 0 &&
                                                this.state.nonSurveyFiles.map((file: INonSurveyFile) =>

                                                    <TableRow key={file.fileId} sx={{ height: '20px', alignItems: 'center' }}>
                                                        <TableCell><Link to={'/submissionHome/' + file.submissionID + "/" + file.component + "/" + file.productLine}>{file.fileName}</Link></TableCell>
                                                        <TableCell>{file.submissionID}</TableCell>
                                                        <TableCell>{(!file.isProcessed ? <LoadingDisplay size={25} /> :
                                                            <Tooltip title={'Processed'} aria-label={'Processed'}>
                                                                <SuccessIcon />
                                                            </Tooltip>
                                                        )}
                                                        </TableCell>
                                                        <TableCell>
                                                            {file.isValidated && this.renderNonSurveyValidationStatus(file)}
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                        </TableBody>
                                    </Table>
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell style={{ verticalAlign: 'top' }}>
                                                    <ProcessingDisplay completed={true}></ProcessingDisplay>
                                                </TableCell>
                                                <TableCell style={{ verticalAlign: 'top' }}>
                                                    <Typography variant='body1' sx={{ color: 'success.main' }}>Submission files processed. Please go to Submissions in the left panel to review individual submissions.</Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                        : ''}
                </div>
                <div>
                    {this.props.uploadFileType !== SubmissionType.HEDIS &&
                        this.state.surveyFiles != null &&
                        this.state.surveyFiles.length > 0 ?
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <Box sx={{ mb: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                    <Fab sx={{ borderRadius: 1 }} variant="extended" color="primary" size="small"
                                        onClick={this.downloadAllReports}
                                        disabled={this.state.surveyFiles.every(f => !f.errorMessage)}>
                                        <GetAppIcon sx={{ mr: 1 }} />
                                        Download All
                                    </Fab>
                                </Box>
                                <TableContainer component={Paper}>
                                    <Table className='table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>File Name</TableCell>
                                                <TableCell>Submission ID</TableCell>
                                                <TableCell>Processing Status</TableCell>
                                                <TableCell>Submission Status</TableCell>
                                                <TableCell>Download Report</TableCell> {/* New column */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.surveyFiles != null &&
                                                this.state.surveyFiles.length > 0 &&
                                                this.state.surveyFiles.map((file: ISurveyFile) =>
                                                    <TableRow key={file.fileId} sx={{ height: '20px', alignItems: 'center' }}>
                                                        <TableCell>{file.fileName}</TableCell>
                                                        <TableCell>{file.submissionID}</TableCell>
                                                        <TableCell>{(!file.isProcessed ? <LoadingDisplay size={25} /> :

                                                            <Tooltip title={'Processed'} aria-label={'Processed'}>
                                                                <SuccessIcon />
                                                            </Tooltip>
                                                        )}
                                                        </TableCell>
                                                        <TableCell>
                                                            {file.isProcessed && this.renderSurveySubmissionStatus(file)}
                                                        </TableCell>
                                                        <TableCell>
                                                            {file.errorMessage &&
                                                                <button
                                                                    onClick={() => {
                                                                        const blob = new Blob([file.errorMessage], { type: "text/plain" });
                                                                        const url = URL.createObjectURL(blob);
                                                                        const a = document.createElement("a");
                                                                        a.href = url;
                                                                        a.download = `${file.fileName}_errors.txt`;
                                                                        a.click();
                                                                        URL.revokeObjectURL(url);
                                                                    }}
                                                                >
                                                                    Download
                                                                </button>
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                        </TableBody>
                                    </Table>
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell style={{ verticalAlign: 'top' }}>
                                                    <ProcessingDisplay completed={true}></ProcessingDisplay>
                                                </TableCell>
                                                <TableCell style={{ verticalAlign: 'top' }}>
                                                    <Typography variant='body1' sx={{ color: 'success.main' }}>Submission files processed. Please go to Submissions in the left panel to review individual submissions.</Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                        : ''}
                </div>
            </Box>
        );
    }

    private onDragEnter = () => {
        this.enableDisableDropActive(true);
    }

    private onDragLeave = () => {
        this.enableDisableDropActive(false);
    }

    // upload the files (dropped in dropzone) to server
    private onDrop = (acceptedFiles, rejectedFiles) => {
        // set initial state
        this.setInitialState();

        const data = new FormData();
        if (acceptedFiles.length === 0) {
            this.setState({ uploadValidationMessages: [this.CreateValidationMessage('Please select a valid file')] });

            this.enableDropzone();
            this.enableDisableDropActive(false);
            return;
        }

        this.enableDisableDropActive(false);
        this.setState({
            processingFiles: true,
            uploadValidationMessages: []
        });

        acceptedFiles.forEach(file => {
            data.append("files", file, file.name);
        });
        const localTransactionId = uuidv4();
        this.setState({ transactionId: localTransactionId });

        const req = request.post(process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + "/api/bulkupload/uploadfiles");
        req.query({ submissionType: this.props.uploadFileType });
        req.query({ transactionId: localTransactionId });
        req.set({ 'Authorization': 'Bearer ' + this.props.user.access_token });

        // show upload progress
        req.on('progress', event => {
            const percent = Math.floor(event.percent);
            if (!isNaN(percent)) {
                if (percent >= 100) {

                    this.setState({ completed: 100, uploadValidationMessages: [], processingText: "", });
                } else {
                    this.setState({ completed: percent });
                }
            }
        });

        setTimeout(
            () => this.spinWait(),
            1000
        );



        // send file(s) to server
        req.send(data).end();
        //    .end((err, res) => this.postUploadFiles(err, res));
    };

    private spinWait = async () => {

        const bulkCall = DbService.GetBulkTransactions$(this.props.user, this.state.transactionId);

        const transactionText = await firstValueFrom(bulkCall);
        if (transactionText instanceof AjaxError || transactionText === null) {
            if (this.state.processingFiles) {
                setTimeout(
                    () => this.spinWait(),
                    2000
                );
            }
            return;
        }
        else {
            var finalStrings = [];

            if (transactionText != null && transactionText.length > 0) {
                finalStrings = transactionText.filter((x) => x.startsWith("{"));
            }
            if (finalStrings !== null && finalStrings.length !== 0) {
                var finalString = finalStrings[0];
                var result = JSON.parse(finalString);
                if (result.fatalError === true) {
                    this.setState({ uploadValidationMessages: [this.CreateValidationMessage("Unexpected error occurred during upload. Please contact NCQA support.")] });
                    this.enableDropzone();
                    this.enableDisableDropActive(true);
                    this.setState({ processingFiles: false });
                    return;
                }

                if (result.uploadDetail && result.uploadDetail.fileUploaded === false && !result.uploadDetail.validationResult.validationSuccessful) {
                    this.setState({ uploadValidationMessages: result.uploadDetail.validationResult.messages });
                }
                if (result.uploadDetail && result.uploadDetail.fileUploaded === true && !result.uploadDetail.validationResult.validationSuccessful) {
                    this.setState({ uploadValidationMessages: [this.CreateValidationMessage('Validations issue(s) found')] });
                }

                if (this.props.uploadFileType === SubmissionType.HEDIS) {
                    this.setState({ nonSurveyFiles: result.uploadDetail.nonSurveyFiles });
                }
                else {
                    this.setState({ surveyFiles: result.uploadDetail.surveyFiles });
                }

                this.enableDropzone();
                this.enableDisableDropActive(true);
                this.setState({ processingFiles: false });
            }
            else {
                var newText = transactionText.join("\n");
                this.setState({ processingText: newText });
            }
        }


        if (this.state.processingFiles) {
            setTimeout(
                () => this.spinWait(),
                2000
            );
        }

    }


    private renderDownloadReportLink = (onClick, isDownloading, primaryText) => {
        return (
            <ListItemButton alignItems='flex-start' divider onClick={onClick}>
                <ListItemIcon>
                    {isDownloading ?
                        (<Fade in={isDownloading}
                            style={{ transitionDelay: "800ms" }}
                            unmountOnExit={true}>
                            <CircularProgress color="secondary" size={20} />
                        </Fade>)
                        : <GetAppIcon />}
                </ListItemIcon>
                <ListItemText
                    primary={primaryText}
                    primaryTypographyProps={{ color: 'primary.main' }}
                    secondaryTypographyProps={{ color: 'text.secondary' }}
                />
            </ListItemButton>
        );
    }

    private async downloadBulkFiles() {

        this.setState({ isDownloadValidationReport: true });
        var submissionsToGet: ISelectedSubmissions[];
        if (this.state.nonSurveyFiles && this.state.nonSurveyFiles.length > 0) {
            submissionsToGet = this.state.nonSurveyFiles.map(i => {
                return {
                    submissionId: i.submissionID,
                    productLine: i.productLine,
                    component: i.component
                };
            });
        }
        if (this.state.surveyFiles && this.state.surveyFiles.length > 0) {
            submissionsToGet = this.state.surveyFiles.map(i => {
                return {
                    submissionId: i.submissionID,
                    productLine: i.productLine,
                    component: i.component
                };
            });
        }
        const desiredFiles: number[] = [3];// This is the validation file type
        const bulkSubs: ISelectedSubmissionsHolder = {
            submissions: submissionsToGet,
            fileTypes: desiredFiles
        }


        const retval = await firstValueFrom(
            SubmissionsService.GetBulkFiles$(
                this.props.user,
                bulkSubs
            )
        );
        if (retval instanceof AjaxError || !retval) {
            //   this.setRedirectState();
        }
        else {
            if (retval.response.isValidDownload) {
                const data = SharedUtility.Str2ab$(atob(retval.response.fileContents));
                saveAs(
                    new Blob([data], { type: "application/octet-stream" }),
                    retval.response.fileName
                );
            }
        }

        this.setState({ isDownloadValidationReport: false });
    }

    private getUploadReport = async () => {
        this.setState({ isDownloadUploadReport: true });
        const apiCall = ReportService.GetUploadReportCaller(this.props.user, this.state.transactionId);

        try {
            const userResponse = await firstValueFrom(apiCall);
            if (typeof userResponse === 'string') {
                const data = SharedUtility.Str2ab$(atob(userResponse));
                saveAs(new Blob([data], {
                    type: "application/octet-stream"
                }), "UploadReport.xlsx");
            }
        }
        catch (ex) {
            // handle error
        }
        finally {
            this.setState({ isDownloadUploadReport: false });
        }
    }

    private downloadAllReports = async () => {
        const zip = new JSZip();
        this.state.surveyFiles
            .filter(f => f.errorMessage)
            .forEach(f => {
                zip.file(`${f.fileName}_errors.txt`, f.errorMessage);
            });
        const blob = await zip.generateAsync({ type: 'blob' });
        saveAs(blob, 'DQS_Reports.zip');
    }

    private getValidationMessageList = () => {
        return (
            <ul style={{ margin: 0, listStyle: 'none' }}>
                {this.state.uploadValidationMessages.map(function (valMessage, i) {
                    return (<li key={"message" + i} dangerouslySetInnerHTML={{ __html: SharedUtility.NewLinesToBreaks$(valMessage.message) }}></li>)
                })}
            </ul>
        );
    }

    private enableDropzone = () => {
        // enable dropzone
        this.setState({ disableDropzone: false });
    }

    private enableDisableDropActive(isActive) {
        this.setState({ dropzoneActive: isActive });
    }

    private setInitialState = () => {
        this.setState({
            completed: 0,
            nonSurveyFiles: [],
            surveyFiles: [],
            disableDropzone: true,
            showDownloadLink: false,
            filesNotProcessed: []
        });
    }

    private renderNonSurveyValidationStatus = (file: INonSurveyFile) => {
        let div;
        if (file.isValidated) {
            switch (file.validationStatus) {
                case StatusType.Success:
                case StatusType.NoIssues:
                    div = <StatusBox status="Success">No issues</StatusBox>
                    break;
                case StatusType.WarningsAndErrors:
                    div = <StatusBox status="Error" sx={{ width: "170px" }}>Warnings and Errors</StatusBox>
                    break;
                case StatusType.Error:
                    div = <StatusBox status="Error">Error</StatusBox>
                    break;
                case StatusType.Fatal:
                    div = <StatusBox status="Error">Fatal</StatusBox>
                    break;
                case StatusType.SchemaError:
                    div = <StatusBox status="Error">Schema error</StatusBox>
                    break;
                case StatusType.Warning:
                    div = <StatusBox status="Warning">Warning</StatusBox>
                    break;
            }
        }
        return div;
    }

    private renderSurveySubmissionStatus = (file: ISurveyFile) => {
        let retdiv = <div />
        if (file.isValidated) {
            switch (file.submissionStatus) {
                case StatusType.NotSubmitted:
                    retdiv = <StatusBox status="NotSubmitted">Not submitted</StatusBox>
                    break;
                case StatusType.Submitted:
                    retdiv = <StatusBox status="Submitted">Submitted</StatusBox>
                    break;
                case StatusType.NoIssues:
                case StatusType.Processed:
                    retdiv = <StatusBox status="Processed">Processed</StatusBox>
                    break;
                case StatusType.WarningsAndErrors:
                    retdiv = <StatusBox status="Error" sx={{ width: "170px" }}>Warnings and Errors</StatusBox>
                    break;
                case StatusType.Error:
                    retdiv = <StatusBox status="Error">Error</StatusBox>
                    break;
                case StatusType.Fatal:
                    retdiv = <StatusBox status="Error">Fatal</StatusBox>
                    break;
                case StatusType.SchemaError:
                    retdiv = <StatusBox status="Error">Schema error</StatusBox>
                    break;
                case StatusType.Warning:
                    retdiv = <StatusBox status="Warning">Warning</StatusBox>
                    break;
            }
        }
        return retdiv;

    }

    private CreateValidationMessage = (message: string): ValidationMessage => {
        return { message: message, severity: 4 };
    }
}

// STYLES CONTAINER
const BulkUploadDropzone = BulkUploadDropzoneView;

export default BulkUploadDropzone;
